import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class AlteracaoCadastralClienteService {

  constructor(
    private httpService: HttpService,
    private http: HttpService
  ) { }

  buscaCliente(data: any, successHandle: Function, errorHandle: Function) {

    this.httpService.doGet('/backoffice/enterprise', data, successHandle, errorHandle);

  }

  updateEnterpriseData(path:any, data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doPost('/enterprise/updateEnterpriseData?'+path, data, successHandle, errorHandle);

  }

}
